import type React from 'react';
import classNames from 'classnames';

interface RadioIconProps {
  isSelected: boolean;
}

const RadioIcon = ({ isSelected }: RadioIconProps): React.JSX.Element => (
  <span
    className={classNames(
      'flex-shrink-0 w-4 h-4 rounded-full border-2 flex items-center justify-center transition-colors duration-100',
      isSelected ? 'border-navy-600 bg-navy-600' : 'border-gray-300',
    )}
  >
    <span
      className={classNames(
        'w-1.5 h-1.5 rounded-full bg-white transition-opacity duration-100',
        isSelected ? 'opacity-100' : 'opacity-0',
      )}
    />
  </span>
);

export default RadioIcon;
